import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "frenteya_session";
const SENT_KEY = "frenteya_visit_sent";

const getSessionId = () => {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = (crypto.randomUUID && crypto.randomUUID()) || `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
};

/**
 * Trackea una visita anónima 1 vez por sesión de navegador (sessionStorage).
 * No bloquea render; falla silenciosamente.
 */
export const useVisitTracker = () => {
  useEffect(() => {
    if (sessionStorage.getItem(SENT_KEY)) return;
    const sid = getSessionId();
    // Endpoint corto (/api/v) para evitar bloqueo por adblockers que filtran "track"/"analytics"
    // Usamos sendBeacon como primera opción (más resistente y no bloquea el unload)
    const url = `${API}/v`;
    const payload = JSON.stringify({
      session_id: sid,
      path: window.location.pathname + window.location.hash,
      referrer: document.referrer || "",
    });
    try {
      if (navigator.sendBeacon) {
        const blob = new Blob([payload], { type: "application/json" });
        const ok = navigator.sendBeacon(url, blob);
        if (ok) {
          sessionStorage.setItem(SENT_KEY, "1");
          return;
        }
      }
    } catch (e) { /* fallback to axios */ }
    axios
      .post(url, JSON.parse(payload))
      .then(() => sessionStorage.setItem(SENT_KEY, "1"))
      .catch(() => {});
  }, []);
};

export default useVisitTracker;
